import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";

const TITLE = "حاسبة ذكرى الزواج - حساب مدة الزواج وموعد الذكرى القادمة";
const DESCRIPTION = "احسب مدة زواجك بالسنوات والأشهر والأيام بدقة، وتعرف على موعد ذكرى زواجك القادمة. أداة متكاملة تقدم لك اقتراحات لهدايا الذكرى حسب العادات والتقاليد والصيحات الحديثة.";
const KEYWORDS = "حاسبة ذكرى الزواج, حساب مدة الزواج, موعد ذكرى الزواج, هدايا ذكرى الزواج, حاسبة العلاقات, حاسبة الذكريات";
const OG_URL = "https://do-calculate.com/calculator/ar/wedding-anniversary-calculator/";

const ANNIVERSARY_GIFTS = {
  1: "هدية الورق (أو الساعات الحديثة)",
  2: "هدية القطن (أو الخزف)",
  3: "هدية الجلد (أو الزجاج)",
  4: "هدية الفاكهة/الزهور (أو الأجهزة الإلكترونية)",
  5: "هدية الخشب (أو الفضة)",
  10: "هدية القصدير/الألومنيوم (أو الماس)",
  15: "هدية الكريستال",
  20: "هدية البورسلين",
  25: "هدية الفضة",
  30: "هدية اللؤلؤ",
  40: "هدية الياقوت",
  50: "هدية الذهب",
  60: "هدية الماس"
};

const GREGORIAN_MONTHS = [
  "يناير / كانون الثاني", "فبراير / شباط", "مارس / آذار", "أبريل / نيسان",
  "مايو / أيار", "يونيو / حزيران", "يوليو / تموز", "أغسطس / آب",
  "سبتمبر / أيلول", "أكتوبر / تشرين الأول", "نوفمبر / تشرين الثاني", "ديسمبر / كانون الأول"
];
function Calculator() {
  const [weddingDateState, setWeddingDateState] = useState({
    day: "1",
    month: "1",
    year: "2020"
  });
  const [results, setResults] = useState(null);
  const [error, setError] = useState("");

  const calculateAnniversary = () => {
    const wedding = new Date(
      parseInt(weddingDateState.year),
      parseInt(weddingDateState.month) - 1,
      parseInt(weddingDateState.day)
    );
    const today = new Date();

    if (isNaN(wedding.getTime())) {
      setError("الرجاء إدخال تاريخ الزواج بشكل صحيح");
      setResults(null);
      return;
    }

    if (wedding > today) {
      setError("تاريخ الزواج لا يمكن أن يكون في المستقبل");
      setResults(null);
      return;
    }

    const timeDiff = Math.abs(today - wedding);
    const diffInDays = Math.floor(timeDiff / (1000 * 3600 * 24));
    const diffInMonths = Math.floor(diffInDays / 30.436875);
    const diffInYears = Math.floor(diffInDays / 365.25);

    const nextAnniversary = new Date(wedding);
    nextAnniversary.setFullYear(today.getFullYear());

    if (nextAnniversary < today) {
      nextAnniversary.setFullYear(today.getFullYear() + 1);
    }

    const daysToNextAnniversary = Math.floor((nextAnniversary - today) / (1000 * 3600 * 24));
    const nextYear = diffInYears + 1;
    const traditionalGift = ANNIVERSARY_GIFTS[nextYear] || "يمكنك اختيار هدية خاصة بك";
    const currentGift = ANNIVERSARY_GIFTS[diffInYears] || "يمكنك اختيار هدية خاصة بك";

    setResults({
      years: diffInYears,
      months: diffInMonths % 12,
      days: diffInDays % 365,
      nextAnniversary: nextAnniversary.toLocaleDateString('ar-EG'),
      daysToNextAnniversary,
      traditionalGift,
      currentGift
    });
    setError("");
  };

  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px", lineHeight: "50px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light p-3">
            <div className="row">
              <div>
                <p>
                  هل تتساءل كم سنة مضت على زواجك؟ حاسبة ذكرى الزواج أداة مجانية وسهلة الاستخدام تحسب لك
                  مدة زواجك بدقة بالسنوات والأشهر والأيام، وتخبرك بموعد ذكرى زواجك القادمة وعدد الأيام
                  المتبقية لها. كما توفر الحاسبة اقتراحات لأفضل هدايا ذكرى الزواج المناسبة لكل مرحلة
                  وفق الأعراف التقليدية والاتجاهات العصرية.
                </p>
                <p>طريقة استخدام حاسبة ذكرى الزواج:</p>
                <ul>
                  <li>اختر يوم وشهر وسنة الزواج من القوائم أدناه</li>
                  <li>اضغط على زر "احسب" للحصول على النتائج فورًا</li>
                  <li>ستظهر لك مدة زواجك بالتفصيل، وموعد ذكراك القادمة، واقتراحات الهدايا المناسبة</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group d-flex align-items-center flex-wrap gap-2">
                    <b>
                      <label className="form-label ms-2 mb-0">تاريخ الزواج</label>
                    </b>
                    <div className="d-flex gap-2">
                      <select
                        className="form-control"
                        style={{ width: "80px" }}
                        value={weddingDateState.day}
                        onChange={(e) => setWeddingDateState({ ...weddingDateState, day: e.target.value })}
                      >
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                          <option key={d} value={d}>{d}</option>
                        ))}
                      </select>
                      <select
                        className="form-control"
                        style={{ width: "180px" }}
                        value={weddingDateState.month}
                        onChange={(e) => setWeddingDateState({ ...weddingDateState, month: e.target.value })}
                      >
                        {GREGORIAN_MONTHS.map((m, i) => (
                          <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                        ))}
                      </select>
                      <select
                        className="form-control"
                        style={{ width: "100px" }}
                        value={weddingDateState.year}
                        onChange={(e) => setWeddingDateState({ ...weddingDateState, year: e.target.value })}
                      >
                        {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(y => (
                          <option key={y} value={y}>{y}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateAnniversary}
                  >
                    احسب
                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      خطأ: {error}
                    </p>
                  ) : (
                    <>
                      { results && (
                        <>
                          <p className="p-3 mb-2 bg-info">
                            مدة زواجك: {results.years} سنة و {results.months} شهر و {results.days} يوم
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            ذكرى زواجك القادمة: {results.nextAnniversary} (بعد {results.daysToNextAnniversary} يوم)
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            هذه السنة تحتفلون بذكرى زواجكم رقم: {results.years + 1}
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            اقتراح هدية الذكرى القادمة: {results.traditionalGift}
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            هدية الذكرى الحالية: {results.currentGift}
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            تهانينا! لقد قضيتم معًا {Math.floor(results.months + (results.years * 12))} شهر و {results.days} يوم من الحب والتفاهم
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                حاسبة ذكرى الزواج - احسب كم سنة مضت على زواجك
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                حاسبة ذكرى الزواج هي أداة رقمية مجانية تتيح للأزواج معرفة كم سنة ومدة مضت على زواجهم بدقة تامة.
                تعتمد الحاسبة على تاريخ الزواج لتحسب المدة بالسنوات والأشهر والأيام، وتحدد موعد ذكرى الزواج القادمة
                وعدد الأيام المتبقية لها، فضلًا عن تقديم اقتراحات لهدايا ذكرى الزواج المتعارف عليها لكل سنة.
                سواء كنت تبحث عن الاحتفال بذكرى زواجك الأولى أو الذكرى الذهبية الخمسين، ستجد هنا كل ما تحتاجه.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف تعمل حاسبة ذكرى الزواج؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                يكفي أن تُدخل تاريخ زواجك ثم تضغط على "احسب"، وستحصل فورًا على النتائج التالية:
              </p>
              <ul>
                <li><strong>مدة الزواج</strong>: بالسنوات والأشهر والأيام منذ يوم الزفاف حتى اليوم</li>
                <li><strong>موعد الذكرى القادمة</strong>: التاريخ الدقيق لذكرى زواجك هذا العام أو العام القادم</li>
                <li><strong>العد التنازلي</strong>: عدد الأيام المتبقية حتى حلول ذكرى زواجك</li>
                <li><strong>هدايا الذكرى</strong>: اقتراحات تقليدية وعصرية مناسبة لكل سنة</li>
              </ul>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هي هدايا ذكرى الزواج المناسبة لكل سنة؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                لكل ذكرى زواج هدية تقليدية متعارف عليها في كثير من دول العالم، وتعكس عمق العلاقة وتطورها عبر السنين:
              </p>
              <ul>
                <li><strong>الذكرى الأولى:</strong> هدايا ورقية أو ساعات — رمز لبداية قصة الحياة المشتركة</li>
                <li><strong>الذكرى الخامسة:</strong> هدايا خشبية أو فضية — رمز للصلابة والثبات</li>
                <li><strong>الذكرى العاشرة:</strong> هدايا من القصدير أو الألومنيوم — رمز للمرونة والصمود</li>
                <li><strong>الذكرى الخامسة عشرة:</strong> هدايا كريستالية — رمز للصفاء والشفافية</li>
                <li><strong>الذكرى الفضية (25 سنة):</strong> هدايا فضية — تكريم لربع قرن من الحب</li>
                <li><strong>الذكرى الذهبية (50 سنة):</strong> هدايا ذهبية — قمة الوفاء والعطاء</li>
                <li><strong>الذكرى الماسية (60 سنة):</strong> هدايا ماسية — أنفس ما يمكن تقديمه</li>
              </ul>
              <p>
                احتفل بكل ذكرى زواج بطريقة مميزة تليق بمسيرتكم المشتركة. استخدم حاسبة ذكرى الزواج لمعرفة
                الهدية المثالية التي تناسب سنوات زواجك بالضبط.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                أسئلة شائعة حول حساب ذكرى الزواج
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                <strong>كيف أحسب كم سنة مضت على زواجي؟</strong><br />
                أدخل تاريخ زواجك في حاسبة ذكرى الزواج أعلاه واضغط "احسب"، ستجد المدة الكاملة بالسنوات والأشهر والأيام.
              </p>
              <p>
                <strong>متى تكون ذكرى الزواج الذهبية؟</strong><br />
                تُحتفل بالذكرى الذهبية للزواج بعد مرور 50 سنة كاملة على يوم الزفاف، وهي من أعظم المحطات في حياة الأزواج.
              </p>
              <p>
                <strong>ما الفرق بين الذكرى الفضية والذهبية؟</strong><br />
                الذكرى الفضية تصادف السنة الخامسة والعشرين من الزواج، أما الذكرى الذهبية فتصادف السنة الخمسين.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
export default Calculator;
